let getIdTokenFn = null;

export const setTokenProvider = (fn) => {
  getIdTokenFn = fn;
};

export const getAuthHeaders = async () => {
  if (!getIdTokenFn) {
    return {};
  }

  const token = await getIdTokenFn();
  if (!token) {
    return {};
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};
